"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

exports.I18nContext = react_1.default.createContext(null);
exports.I18nIdsContext = react_1.default.createContext([]);
exports.I18nParentContext = react_1.default.createContext(null);